module["exports"] = [
  "#####",
  "### ##",
  "###-##"
];
